window.themeProductSizeUnits = (() => {
  const centimetersPerInch = 2.54;
  const numberPattern = '(?:\\d+(?:\\.\\d+)?|\\.\\d+)';
  const createMeasurementPattern = () => new RegExp(
    `(${numberPattern})(?:\\s*([–—-])\\s*(${numberPattern}))?\\s*(cm|inch(?:es)?)\\b`,
    'gi'
  );

  const normalizeUnit = (unit) => String(unit).toLowerCase() === 'cm' ? 'cm' : 'inch';

  const readMeasurements = (label) => {
    const source = String(label);
    const measurements = [];

    for (const match of source.matchAll(createMeasurementPattern())) {
      measurements.push({
        start: match.index,
        end: match.index + match[0].length,
        first: Number(match[1]),
        second: match[3] == null ? null : Number(match[3]),
        separator: match[2] || '–',
        unit: normalizeUnit(match[4])
      });
    }

    return measurements;
  };

  const formatNumber = (value, unit) => {
    const precision = unit === 'cm' ? 1 : 2;
    return value.toFixed(precision).replace(/\.?0+$/, '');
  };

  const formatMeasurement = (measurement, targetUnit, convert) => {
    const factor = convert
      ? (targetUnit === 'cm' ? centimetersPerInch : 1 / centimetersPerInch)
      : 1;
    const first = convert
      ? formatNumber(measurement.first * factor, targetUnit)
      : String(measurement.first);
    const second = measurement.second == null
      ? null
      : (convert ? formatNumber(measurement.second * factor, targetUnit) : String(measurement.second));
    const value = second == null ? first : `${first}${measurement.separator}${second}`;

    return `${value} ${targetUnit}`;
  };

  const trimMeasurementWrapper = (value) => String(value)
    .replace(/^[\s(/|,;\[]+/, '')
    .replace(/[\s)/|,;\]]+$/, '')
    .trim();

  const isPairedMeasurementLabel = (source, measurements) => {
    if (measurements.length !== 2 || measurements[0].unit === measurements[1].unit) return false;

    const separator = source.slice(measurements[0].end, measurements[1].start);
    return separator.replace(/[\s()[\]/|,;]+/g, '') === '';
  };

  const format = (label, requestedUnit) => {
    const source = String(label);
    const targetUnit = normalizeUnit(requestedUnit);
    const measurements = readMeasurements(source);

    if (!measurements.length) return source;

    if (isPairedMeasurementLabel(source, measurements)) {
      const firstMeasurement = measurements[0];
      const lastMeasurement = measurements[measurements.length - 1];
      const prefix = trimMeasurementWrapper(source.slice(0, firstMeasurement.start));
      const suffix = trimMeasurementWrapper(source.slice(lastMeasurement.end));
      const targetMeasurements = measurements
        .filter(({ unit }) => unit === targetUnit)
        .map((measurement) => formatMeasurement(measurement, targetUnit, false));

      return [prefix, targetMeasurements.join(' / '), suffix].filter(Boolean).join(' ');
    }

    let output = '';
    let cursor = 0;
    measurements.forEach((measurement) => {
      output += source.slice(cursor, measurement.start);
      output += formatMeasurement(measurement, targetUnit, measurement.unit !== targetUnit);
      cursor = measurement.end;
    });

    return output + source.slice(cursor);
  };

  const hasMeasurements = (labels) => labels.some((label) => readMeasurements(label).length > 0);

  return Object.freeze({ format, hasMeasurements, normalizeUnit });
})();

window.dispatchEvent?.(new CustomEvent('product-size-units:ready'));
